import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TicketStatuses } from "app/enums/TicketStatuses.enum";
import { environment } from "../../../../../environments/environment";
import { ITicket } from "./../../../../interfaces/i-ticket";

@Component({
  standalone: false,
    selector: "fuze-dialog-detail",
    templateUrl: "./detail.component.html",
    styleUrls: ["./detail.component.scss"],
})
export class DetailComponent implements OnInit {
    ticket: ITicket;
    statusesTicket = TicketStatuses;
    canDeleteTicket: boolean;
    hoursBeforeDeletion: number;

    public email: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DetailComponent>
    ) { }

    ngOnInit() {
        this.ticket = this.data.ITicket;
        this.canDeleteTicket = this.data.canDeleteTicket;
        this.hoursBeforeDeletion = environment.timeHoursBeforeDeletion;
        this.email = environment.systemMailTicketScheduled;
    }

    onDeleteEvent() {
        this.dialogRef.close({ cta: "delete", ticket: this.ticket });
    }

    goToVideochat() {
        this.dialogRef.close({ cta: "goToVideochat", ticket: this.ticket });
    }
}
